import React from 'react';
import { PropTypes } from '../../../utils/propTypes';
import { Icon } from '../Icon';
import styles from './Spinner.module.css';

/**
 * Spinner — an indeterminate loading indicator, shadcn-style. Renders the
 * lucide loader glyph through the Icon layer (registry `spinner` → LoaderCircle)
 * so it never imports lucide directly (CI rule). `role="status"` +
 * aria-label="Loading".
 *
 * Sizing: with no `size` it is `1em` so it scales with the surrounding
 * font-size (e.g. inside a Button or Badge); pass `size` (xs|sm|md|lg|xl or a
 * px number) for a fixed size. Color inherits via currentColor. Compose inside
 * a Button/Badge with `data-icon="inline-start|inline-end"` (forwarded to the
 * glyph) to place it before/after a label.
 */
const Spinner = ({ size = undefined, className = '', ...props }) => (
  <Icon
    name="spinner"
    label="Loading"
    role="status"
    size={size}
    className={`${styles.spin} ${size === undefined ? styles.em : ''} ${className}`.trim()}
    {...props}
  />
);

Spinner.propTypes = {
  // size accepts a keyword string or a px number — validated at the call site.
  className: PropTypes.string,
};

export default Spinner;
export { Spinner };
